module.exports = __webpack_public_path__ + "img/3b.ebcbf695.jpg";